const countryCodes = {
	Afghanistan: "93",
	Albania: "355",
	Algeria: "213",
	Angola: "244",
	Argentina: "54",
	Armenia: "374",
	Australia: "61",
	Austria: "43",
	Azerbaijan: "994",
	Bahrain: "973",
	Bangladesh: "880",
	Belarus: "375",
	Belgium: "32",
	Benin: "229",
	Bolivia: "591",
	Botswana: "267",
	Brazil: "55",
	Bulgaria: "359",
	"Burkina Faso": "226",
	Burundi: "257",
	Cambodia: "855",
	Cameroon: "237",
	Canada: "1",
	Chad: "235",
	Chile: "56",
	China: "86",
	Colombia: "57",
	"Costa Rica": "506",
	Croatia: "385",
	"Czech Republic": "420",
	Denmark: "45",
	"Dominican Republic": "1809",
	Ecuador: "593",
	Egypt: "20",
	"El Salvador": "503",
	Eritrea: "291",
	Ethiopia: "251",
	Finland: "358",
	France: "33",
	Gabon: "241",
	Gambia: "220",
	Georgia: "995",
	Germany: "49",
	Ghana: "233",
	Greece: "30",
	Guatemala: "502",
	"Guinea-Bissau": "245",
	Haiti: "509",
	Honduras: "504",
	"Hong Kong": "852",
	Hungary: "36",
	India: "91",
	Indonesia: "62",
	Iraq: "964",
	Ireland: "353",
	Israel: "972",
	Italy: "39",
	"Ivory Coast": "225",
	Jamaica: "1658",
	Japan: "81",
	Jordan: "962",
	Kenya: "254",
	Kuwait: "965",
	Laos: "856",
	Latvia: "371",
	Lebanon: "961",
	Lesotho: "266",
	Liberia: "231",
	Libya: "218",
	Lithuania: "370",
	Madagascar: "261",
	Malawi: "265",
	Malaysia: "60",
	Mali: "223",
	Mauritania: "222",
	Mexico: "52",
	Moldova: "373",
	Mongolia: "976",
	Morocco: "212",
	Mozambique: "258",
	Namibia: "264",
	Nepal: "977",
	Netherlands: "31",
	"New Zealand": "64",
	Nicaragua: "505",
	Niger: "227",
	Nigeria: "234",
	"North Macedonia": "389",
	Norway: "47",
	Oman: "968",
	Pakistan: "92",
	Panama: "507",
	"Papua New Guinea": "675",
	Paraguay: "595",
	Peru: "51",
	Philippines: "63",
	Poland: "48",
	Portugal: "351",
	"Puerto Rico": "1787",
	Qatar: "974",
	"Republic of the Congo (Brazzaville)": "242",
	Romania: "40",
	Russia: "7",
	Rwanda: "250",
	"Saudi Arabia": "966",
	Senegal: "221",
	Serbia: "381",
	"Sierra Leone": "232",
	Singapore: "65",
	Slovakia: "421",
	Slovenia: "386",
	Somalia: "252",
	"South Africa": "27",
	"South Sudan": "211",
	Spain: "34",
	"Sri Lanka": "94",
	Sudan: "249",
	Swaziland: "268",
	Sweden: "46",
	Switzerland: "41",
	Taiwan: "886",
	Tajikistan: "992",
	Tanzania: "255",
	Thailand: "66",
	Togo: "228",
	Tunisia: "216",
	Turkey: "90",
	Turkmenistan: "993",
	Uganda: "256",
	Ukraine: "380",
	"United Arab Emirates": "971",
	"United Kingdom": "44",
	"United States": "1",
	Uruguay: "598",
	Uzbekistan: "998",
	Venezuela: "58",
	Vietnam: "84",
	Yemen: "967",
	Zambia: "260",
};

export function findCountryByPhoneNumber(phoneNumber) {
	// Check prefixes from longest to shortest (4 digits to 1 digit)
	for (let length = 4; length >= 1; length--) {
		const prefix = phoneNumber.slice(0, length);
		for (const [country, code] of Object.entries(countryCodes)) {
			if (code === prefix) {
				return country;
			}
		}
	}
	return "N/A";
}
